import App from "@frog/source/models/App.js"
import World from "@frog/source/models/World.js"
import Stage from "@frog/source/models/Stage.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"

import Navigation from "@frog/source/engine/navigating/Navigation.js"
import Zone from "@frog/source/models/Zone.js"
import Step from "@frog/source/models/Step.js"
import Objdict from "objdict"
import Geometry from "@frog/source/utility/Geometry.js"

export default function bookScripts ({ending = []} = {}) {
    return [
        {
            "trigger": "turn:every-even:start",
            "events": [
                {
                    "func": (stage) => {
                        if(!!App.game?.chapter?.timer) {
                            App.game.chapter.timer = 0
                        }
                        if(!!App.game?.chapter?.stage?.player?.timeout) {
                            if(stage.player.phase == "ritual") {
                                App.game.chapter.stage.player.timeout = 1 * 60 * 1000
                            } else {
                                App.game.chapter.stage.player.timeout = 5 * 60 * 1000
                            }
                        }
                    }
                }
            ]
        },
        // {
        //     "trigger": "turn:every-odd:start",
        //     "events": [
        //         Step.deltastage({
        //             "unit": {"key": "monster", "role": "visible"},
        //         })
        //     ]
        // },
        // {
        //     "trigger": "turn:every-odd:end",
        //     "events": [
        //         (stage) => {
        //             if(stage.units.monster.state != "aggroed" && stage.units.monster.state != "afraid") {
        //                 return Step.deltastage({
        //                     "unit": {"key": "monster", "role": "invisible"},
        //                 })
        //             }
        //         }
        //     ]
        // },
        {

            "condition": function(stage) {
                return PlotConditions.areAllAffiliatedUnitsDead(stage, {"affiliation": stage.player.affiliation})
            },
            "events": [
                Step.deltastage({
                    "phase": "failure"
                }),
                Step.deltastage({
                    "player": {"phase": "failure"},
                }),
                PlotSteps.PlayStinger("Stinger:Failure"),
                PlotSteps.ChapterFailure(),
                {"func": () => Navigation.go("/games/book/overworld")},
            ]
        },
        {
            "trigger": "before attacking",
            "canBeTriggered": function(stage) {
                return true// stage.turn.affiliation == "good"
                    // && stage.turn.phase == "start"
            },
            "events": [
                (stage) => {
                    let steps = []

                    const monsters = Object.values(stage.units).filter((unit) => unit.affiliation == "bad" && unit.isDead != true)
                    const ritual = Object.values(stage.units).find((unit) => unit.role === "ritual")
                    const scatterables = Object.values(stage.units).filter((unit) => unit.role?.includes("scatterable") && !unit.isDead)

                    monsters.forEach((monster) => {
                        const deathConditionMet = !!ritual && !Object.entries(monster.deathCondition).find(([condition, locations]) => {
                            const allScatterablesOfType = scatterables.filter((scatterable) => scatterable.role.includes(condition))
                            console.log(allScatterablesOfType)
                            return locations.find((location) => {
                                const postitionScatterableNeedsToBe = Geometry.add(ritual.position, location)
                                return !allScatterablesOfType.find((scatterable) => {
                                    return scatterable.position.x === postitionScatterableNeedsToBe.x
                                        && scatterable.position.y === postitionScatterableNeedsToBe.y
                                })

                            })
                        })

                        if(deathConditionMet == true
                        && monster.position.x == ritual?.position.x
                        && monster.position.y == ritual?.position.y) {
                            steps = steps.concat([
                                Step.flag("Cutscene", true),
                                PlotSteps.ShudderUnit({"unitKey": monster.key}),
                                PlotSteps.Wait(600),
                                PlotSteps.KillUnit({"unitKey": monster.key, "duration": 600}),
                                Step.flag("Cutscene", false),
                            ])

                            if(monsters.length <= 1) {
                                steps = steps.concat([
                                    Step.deltastage({
                                        "phase": "success"
                                    }),
                                    Step.deltastage({
                                        "player": {"phase": "success"},
                                    }),
                                    PlotSteps.PlayStinger("Stinger:Success"),
                                    PlotSteps.ChapterSuccessClassic(),
                                    {
                                        "func": () => {
                                            App.lastChapterSlug = parseInt(App.game.chapter.slug)
                                        }
                                    },
                                    ...ending,
                                    (stage) => {
                                        App.game.overworld.bookFlags["contracttableofcontents"] = true
                                        App.game.overworld.bookFlags["missionoverview"] = true
                                        App.game.overworld.bookFlags["nondisclosureproceedures"] = true
                                        App.game.overworld.bookFlags["ooze"] = true
                                        App.game.overworld.bookFlags["demon"] = true
                                        App.game.overworld.bookFlags["eyebeast"] = true
                                    },
                                    PlotSteps.TransitionStart(),
                                    PlotSteps.WaitingModal(1000),
                                    {"func": () => {
                                        if(App.lastChapterSlug == 9) {
                                            Navigation.go("/games/book/credits")
                                        } else {
                                            Navigation.go("/games/book/overworld")
                                        }
                                    }},
                                    PlotSteps.TransitionEnd(),
                                    {
                                        "func": () => {
                                            if(App.game.overworld.locations[App.lastChapterSlug] != undefined) {
                                                App.game.overworld.locations[App.lastChapterSlug].isFinished = true
                                            }
                                            if(App.game.overworld.locations[App.lastChapterSlug + 1] != undefined) {
                                                App.game.overworld.locations[App.lastChapterSlug + 1].isReachable = true
                                            }
                                        }
                                    },
                                ])
                            }
                        }
                    })
                    return steps
                }
            ]
        },
        {
            "condition": function(stage) {
                const scatterables = Object.values(stage.units).filter((unit) => unit.role?.includes("scatterable"))
                if(stage.turn.affiliation == "bad"
                && stage.turn.phase == "end"
                && scatterables.length > 0) {
                    return true
                }
            },
            "events": [
                (stage) => {
                    const scatterables = Object.values(stage.units).filter((unit) => unit.role?.includes("scatterable"))
                    const steps = []
                    scatterables.forEach((scatterable) => {
                        const newHealth = scatterable.health - 10
                        steps.push(PlotSteps.EditUnit({
                            "key": scatterable.key,
                            "health": newHealth,
                        }))
                        if(newHealth <= 0 && scatterable.isDead != true) {
                            steps.push(PlotSteps.KillUnit({"unitKey": scatterable.key}))

                            Object.values(stage.units).forEach((unit) => {
                                if(unit.stimuli != undefined
                                && unit.stimuli["dissolve:" + scatterable.jobKey]) {
                                    steps.push(Step.deltastage({
                                        "unit": {
                                            "key": unit.key,
                                            // "role": "visible",
                                            "state": unit.stimuli["dissolve:" + scatterable.jobKey]
                                        }
                                    }))
                                }
                            })
                        }
                    })
                    return steps
                }
            ]
        },
        {
            "trigger": "moving",
            "canBeTriggered": function(stage) {
                return PlotConditions.hasReachedZone(stage, {"role": "page", "affiliation": "good"})
            },
            "events": [
                {"func": (stage) => {
                    const pageData = stage.units.page
                    pageData.pageKeys.forEach((pageKey) => {
                        App.game.overworld.bookFlags[pageKey] = true
                    })
                }},
                PlotSteps.KillUnit({"unitKey": "page"}),
                "More pages?"
            ]
        },
    ]
}
